import * as yup from 'yup'

export const NUMBER_INVALID_MESSAGE = 'Please enter a valid number.'
export const NUMBER_MIN_ZERO_MESSAGE = 'Please enter a number >= 0.'
export const NUMBER_GREATER_THAN_ZERO_MESSAGE = 'Please enter a number greater than 0.'
export const NUMBER_INTEGER_MESSAGE = 'Please enter an integer number.'

export function requiredMsg(field: string) {
  return `${field} is required.`
}

export function yupPositiveInteger() {
  return yup
    .number()
    .integer(NUMBER_INTEGER_MESSAGE)
    .nullable()
    .positive(NUMBER_GREATER_THAN_ZERO_MESSAGE)
    .typeError(NUMBER_INVALID_MESSAGE)
}

export function yupNullableMinZeroInteger() {
  return yup
    .number()
    .integer(NUMBER_INTEGER_MESSAGE)
    .min(0, NUMBER_MIN_ZERO_MESSAGE)
    .nullable()
    .typeError(NUMBER_INVALID_MESSAGE)
}

export function yupNullableMinZeroDecimal() {
  return yup.number().min(0, NUMBER_MIN_ZERO_MESSAGE).nullable().typeError(NUMBER_INVALID_MESSAGE)
}

const MIN_SEASON = 2000
const MAX_SEASON = 2100

export function yupSeasonYear() {
  return yupPositiveInteger()
    .min(MIN_SEASON + 1, `Analysis season must be greater than ${MIN_SEASON}`)
    .max(MAX_SEASON - 1, `Analysis season must be less than ${MAX_SEASON}`)
    .required('A valid year (e.g. 2018) must be entered')
}
